import { useContext } from 'react';
import { IPInfoContext } from 'ip-info-react';
import { UAParser } from 'ua-parser-js';
import useLocalStorage from './useLocalStorage';
import { pick } from 'lodash';

export const USER_DATA_LOCAL_STORAGE_KEY = 'userDeviceData';

export const useUserDeviceData = () => {
  const userIPInfo = useContext(IPInfoContext);
  const [, setLocalStorageItem] = useLocalStorage(
    USER_DATA_LOCAL_STORAGE_KEY,
    {}
  );

  const setUserDeviceData = () => {
    const parser = new UAParser();
    const userDeviceData = parser.getResult();

    setLocalStorageItem({
      ipInfo: pick(userIPInfo, [
        'ip',
        'network',
        'version',
        'city',
        'region',
        'country_name',
        'country_code',
        'in_eu',
        'postal',
        'asn',
        'org'
      ]),
      deviceData: {
        ua: userDeviceData.ua,
        browser: pick(userDeviceData.browser, ['name', 'version']),
        device: pick(userDeviceData.device, ['model', 'vendor']),
        engine: pick(userDeviceData.engine, ['name', 'version']),
        os: pick(userDeviceData.os, ['name', 'version'])
      }
    });
  };

  const resetUserDeviceData = () => {
    setLocalStorageItem({});
  };

  return { setUserDeviceData, resetUserDeviceData };
};
